import { Platform, StyleSheet } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography';
import { ticketColors } from '../../../shared/theme/ticketColors'
import { ticketSurfaces } from '../../../shared/ticket/ticketSurfaces.styles';

export const supportStyles = StyleSheet.create({
  warn: {
    color: '#B45309',
    marginBottom: spacing.sm,
    ...typography.body,
  },
  hero: {
    marginBottom: spacing.md,
    gap: spacing.sm,
  },
  heroSubtitle: {
    ...typography.body,
    color: ticketColors.ink2,
    lineHeight: 20,
  },
  heroCta: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.sm,
    alignSelf: 'flex-start',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
    minHeight: 44,
  },
  heroCtaText: {
    ...typography.body,
    fontWeight: '700',
    color: ticketColors.brandInk,
  },
  listContent: {
    paddingBottom: spacing.xl * 2,
  },
  workspaceEmpty: {
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: spacing.xl * 2,
    paddingHorizontal: spacing.lg,
    gap: spacing.sm,
  },
  workspaceEmptyCta: {
    marginTop: spacing.sm,
    height: 44,
    borderRadius: 10,
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: spacing.lg,
    minWidth: 200,
  },
  workspaceEmptyCtaText: {
    ...typography.body,
    fontWeight: '700',
    color: ticketColors.brandInk,
  },
  softCta: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.sm,
    alignSelf: 'flex-start',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
    minHeight: 44,
  },
  softCtaText: {
    ...typography.body,
    fontWeight: '700',
    color: ticketColors.brandInk,
  },
  softCtaSolid: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.sm,
    alignSelf: 'stretch',
    paddingVertical: spacing.sm,
    paddingHorizontal: spacing.md,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.gold,
    minHeight: 44,
  },
  softCtaSolidText: {
    ...typography.body,
    fontWeight: '700',
    color: '#fff',
  },
  rowDenseBody: {
    gap: spacing.xs,
  },
  rowSelectedWrap: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
  },
  rowUnreadWrap: {
    backgroundColor: ticketColors.brandSoft,
  },
  rowMain: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.sm,
  },
  rowContent: {
    flex: 1,
    minWidth: 0,
    gap: spacing.xs,
  },
  rowTop: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
  },
  rowType: {
    ...typography.body,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  rowPreview: {
    ...typography.caption,
    color: ticketColors.ink2,
    lineHeight: 20,
  },
  rowMeta: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 4,
  },
  rowMetaText: {
    fontSize: 12,
    color: ticketColors.ink3,
  },
  rowTrailing: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    flexShrink: 0,
    paddingTop: 2,
  },
  workspaceRoot: {
    flex: 1,
    flexDirection: 'row',
    alignSelf: 'stretch',
    width: '100%',
    backgroundColor: ticketColors.bg,
    minHeight: 0,
    minWidth: 0,
    ...(Platform.OS === 'web'
      ? ({ minHeight: '100%' as unknown as number, height: '100%' as unknown as number } as const)
      : null),
  },
  workspaceListPane: {
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: '40%',
    minWidth: 360,
    maxWidth: 520,
    borderRightWidth: StyleSheet.hairlineWidth,
    borderRightColor: ticketColors.ruleSoft,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    minHeight: 0,
  },
  workspaceDetailPane: {
    flex: 1,
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
    minHeight: 0,
    alignSelf: 'stretch',
    paddingHorizontal: spacing.sm,
    paddingVertical: spacing.sm,
    backgroundColor: ticketColors.bg,
  },
  detailEmpty: {
    flex: 1,
    padding: spacing.md,
    minHeight: 0,
  },
  detailEmptyPanel: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.sm,
    padding: spacing.xl,
    ...ticketSurfaces.paperSheet,
  },
  detailEmptyIconWrap: {
    width: 52,
    height: 52,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ticketColors.brandSoft,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    marginBottom: spacing.xs,
  },
  detailEmptyTitle: {
    ...typography.title3,
    color: ticketColors.ink,
    fontWeight: '800',
    textAlign: 'center',
  },
  detailEmptyText: {
    ...typography.body,
    color: ticketColors.ink2,
    textAlign: 'center',
    maxWidth: 360,
    lineHeight: 22,
  },
});
